import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { SITE } from "../config/site";

const ContentContext = createContext({});

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState({});
  useEffect(() => {
    api
      .get("/content")
      .then(({ data }) => setContent(data.values || {}))
      .catch(() => {});
  }, []);
  return <ContentContext.Provider value={content}>{children}</ContentContext.Provider>;
};

export const useContent = (key, fallback) => {
  const content = useContext(ContentContext);
  return content[key] || fallback;
};

export const useBookingUrl = () => useContent("booking_url", SITE.bookingUrl);
